/*
 *= require dropzone
 */

$(function () {

  window.refresh_data = function () {
    $('.refreshing-images').show();
    window.location.reload();
  }

  var old_height, new_height;

  function update_iframe_height() {
    new_height = $(document.body).height();

    if (new_height != old_height) {
      if (parent && typeof parent.refresh_iframe_height == 'function') {
        parent.refresh_iframe_height(new_height);
      }
      old_height = new_height;
    }
  };

  Dropzone.autoDiscover = false;

  $('.dropzone-input').each(function () {
    var $this = $(this),
        $dropzone_preview = $('[data-dropzone-preview=' + $this.attr('data-name') + ']');

    $this.dropzone({
      url: $this.attr('data-url'),
      uploadMultiple: false,
      maxFiles: 1,
      paramName: 'image[upload]',
      addedfile: function (file) {
        $('.modal-footer .btn').addClass('disabled');
        update_iframe_height();
        $dropzone_preview.find('.dropzone-image-preview, .dropzone-input').hide();
        $dropzone_preview.find('.dropzone-image-spinner').show().find('.progress').css('width', '0px').end().find('.name').html('Uploading ' + file.name + '...');
      },
      uploadprogress: function (file, progress) {
        update_iframe_height();

        $dropzone_preview.find('.dropzone-image-spinner').find('.progress').css('width', progress + '%');

        if (progress == 100) {
          $dropzone_preview.find('.dropzone-image-spinner').find('.name').html('Processing and saving ' + file.name + '. Please wait...').end().find('.progress').addClass('processing');
        }
      },
      success: function (file, response) {
        $('.modal-footer .btn').removeClass('disabled');
        if (response.type == 'success') {
          $('.modal-body').html(response.html);

          update_iframe_height();

          if (parent && parent.refresh_data) {
            parent.refresh_data();
          }
        }
      }
    });
  });

  /* dropzone visual cues when dragging */
  $('.dropzone-input').on('dragover', function (e) {
    e.preventDefault();
    $(this).addClass('dragover');
  }).on('dragleave drop', function () {
    $(this).removeClass('dragover');
  });

});
